import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthUser, parseUserRole } from '@ubus/shared';
import { homePathForRole } from '../utils/homePath';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useAuthUser();
  const home = homePathForRole(parseUserRole(user));

  return (
    <div className="admin-status-page">
      <Result
        status="404"
        title="404"
        subTitle={t('status.notFoundSubtitle')}
        extra={
          <Button type="primary" onClick={() => navigate(home)}>
            {t('common.backHome')}
          </Button>
        }
      />
    </div>
  );
}

export default NotFoundPage;
